// extracted by mini-css-extract-plugin
export var arrow = "PackagesBlock-module--arrow--61de3";
export var boost = "PackagesBlock-module--boost--56488";
export var boostActive = "PackagesBlock-module--boostActive--b244c";
export var container = "PackagesBlock-module--container--1144d";
export var content = "PackagesBlock-module--content--bb40f";
export var discover = "PackagesBlock-module--discover--4f318";
export var discoverActive = "PackagesBlock-module--discoverActive--31a9f";
export var header = "PackagesBlock-module--header--91163";
export var hitArea = "PackagesBlock-module--hitArea--c0703";
export var image = "PackagesBlock-module--image--f62d6";
export var imageWrapper = "PackagesBlock-module--imageWrapper--1e093";
export var launch = "PackagesBlock-module--launch--16091";
export var launchActive = "PackagesBlock-module--launchActive--76164";
export var link = "PackagesBlock-module--link--fc570";
export var mobileArrow = "PackagesBlock-module--mobileArrow--a65e0";
export var onwardLink = "PackagesBlock-module--onwardLink--cfec4";
export var packages = "PackagesBlock-module--packages--b4b55";
export var pilot = "PackagesBlock-module--pilot--38b79";
export var pilotActive = "PackagesBlock-module--pilotActive--07a5e";
export var tagline = "PackagesBlock-module--tagline--5506e";
export var thumbnailAlt = "PackagesBlock-module--thumbnailAlt--f59c1";
export var title = "PackagesBlock-module--title--35448";